import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { OrganogramsContext } from '../context/OrganogramsContext';
import { OrganogramModel } from '../../Models/OrganogramModel';
import { OrganogramDto } from '../../Models/OrganogramDto';

export interface IOrganogramProps{    
    level: number,
    error: boolean,    
    parentId: number | null, 
    selected: OrganogramModel | null,
    organogramsList: OrganogramModel[],
    disableFieldClear?: boolean
}

export function Organogram({
    level,
    error,
    parentId,
    selected,
    organogramsList,
    disableFieldClear }: IOrganogramProps) {

    const organogramContext = React.useContext(OrganogramsContext);
    
    const [selectedOrganogram, setSelectedOrganogram] = React.useState<OrganogramModel | null>(selected);

    React.useEffect(() => {        
        setSelectedOrganogram(selected);
        if (organogramsList && organogramsList.length == 1 && selected == null)
            setSelectedOrganogram(organogramsList[0]);                
    }, [parentId]);

    React.useEffect(() => {
        const localList = [...organogramContext.organogramDto];
        
        if (selectedOrganogram) {            
            const found = localList.findIndex((item: OrganogramDto) => item.level == level);
            if (found >= 0) {
                localList[found].selectedOrganogram = (selectedOrganogram ? {...selectedOrganogram} : null);
            }    
            const foundNext = localList.findIndex((item: OrganogramDto) => item.level == level + 1);
            if (foundNext >= 0) {
                localList[foundNext].parentId = selectedOrganogram.id;
                localList[foundNext].selectedOrganogram = null;            
                localList[foundNext].organogramList = selectedOrganogram.organograms;
            } 
            else if (selectedOrganogram) {
                localList.push({ level: level + 1, parentId: selectedOrganogram.id, selectedOrganogram: null, hasOrganograms: false, organogramList: selectedOrganogram.organograms});
            }            
        } else {             
            localList.splice(level, localList.length - level);
        }

        organogramContext.setOrganogramDto(localList);
       
    }, [selectedOrganogram]);    

    const getLabel= () => {
        switch (level) {
        case 1:
            return 'Marcas';
        case 2:
            return 'Área/Departamento';
        case 3:
            return 'Tema';              
        default:
            return `Subtema ${level - 3}`;
        }
    };
    
    return (
        <>            
            { organogramsList.length > 0 &&
                <Autocomplete
                    fullWidth
                    loadingText="Carregando..."
                    noOptionsText="Sem resultados"
                    id={`organogram-${level}`}
                    disableClearable={ disableFieldClear != null ? disableFieldClear : true }
                    value={selectedOrganogram ? selectedOrganogram : (organogramsList.length == 1 ? organogramsList[0] : undefined)}
                    options={organogramsList}
                    onChange={ (_, newValue: OrganogramModel | null) => setSelectedOrganogram(newValue) }                        
                    getOptionLabel={(option) => option.description}
                    renderInput={(params) => 
                        <TextField {...params} 
                            label={getLabel()} 
                            variant="outlined" 
                            error={(error && selectedOrganogram == null)}
                            helperText={(error && selectedOrganogram == null) ? 'Campo obrigatório' : ''} />
                    } />
            }            
        </>
    );
}